import LandingCard from "./landing_card";
import { Box, ButtonBase, Divider, Stack, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TOOLTIPS_EN } from "../../../enums/tooltip_enum_EN";

function CommissioningCard({ commissioningData, handleFilterClick, ...props }) {
  const defaultSort = [{ type: "active_verification_mod_date", value: "true" }];

  const pending_commissioning_start = commissioningData?.pending_commissioning_start
    ? Number(commissioningData.pending_commissioning_start)
    : 0;
  const pending_installer_action = commissioningData?.pending_installer_action
    ? Number(commissioningData.pending_installer_action)
    : 0;
  const pending_start_device_control = commissioningData?.pending_start_device_control
    ? Number(commissioningData.pending_start_device_control)
    : 0;
  const pending_device_control = commissioningData?.pending_device_control
    ? Number(commissioningData.pending_device_control)
    : 0;
  const pending_technical_approval = commissioningData?.pending_technical_approval
    ? Number(commissioningData.pending_technical_approval)
    : 0;
  const pending_contract_approval = commissioningData?.pending_contract_approval
    ? Number(commissioningData.pending_contract_approval)
    : 0;
  const pending_network_operator_metering_data = commissioningData?.pending_network_operator_metering_data
    ? Number(commissioningData.pending_network_operator_metering_data)
    : 0;
  const pending_network_operator_metering_validation = commissioningData?.pending_network_operator_metering_validation
    ? Number(commissioningData.pending_network_operator_metering_validation)
    : 0;

  const sum =
    pending_commissioning_start +
    pending_installer_action +
    pending_start_device_control +
    pending_device_control +
    pending_technical_approval +
    pending_contract_approval +
    pending_network_operator_metering_data +
    pending_network_operator_metering_validation;

  return (
    <LandingCard
      title="Commissioning"
      tooltip={TOOLTIPS_EN.COMMISSIONING_CARD}
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        ...props.sx,
      }}
    >
      <Stack spacing={1}>
        {sum === 0 ? (
          <>
            <Stack sx={{ flexGrow: 1 }}>
              <Typography variant="h6" fontSize={16}>
                {"No sites require commissioning actions"}
              </Typography>
            </Stack>
          </>
        ) : (
          <>
            <>
              <CommissioningItem
                title="Pending commissioning start"
                description="Sites that have not been commissioned"
                value={pending_commissioning_start}
                onClick={() =>
                  handleFilterClick(
                    [
                      {
                        type: "commissioning_completed",
                        value: "false",
                      },
                    ],
                    defaultSort,
                  )
                }
              />
              <Divider />
            </>

            <>
              <CommissioningItem
                title="Pending installer action"
                description="Sites that require an installer to verify data"
                value={pending_installer_action}
                onClick={() =>
                  handleFilterClick(
                    [
                      {
                        type: "commissioning_required_action",
                        value: ["pending installer action"],
                      },
                    ],
                    defaultSort,
                  )
                }
              />
              <Divider />
            </>
            <>
              <CommissioningItem
                title="Pending start device control"
                description="Sites that require an installer to start the control phase"
                value={pending_start_device_control}
                onClick={() =>
                  handleFilterClick(
                    [
                      {
                        type: "commissioning_required_action",
                        value: ["pending start device control"],
                      },
                    ],
                    defaultSort,
                  )
                }
              />
              <Divider />
            </>
            <>
              <CommissioningItem
                title="Pending device control"
                description="Waiting for the control phase to finish"
                value={pending_device_control}
                onClick={() =>
                  handleFilterClick(
                    [
                      {
                        type: "commissioning_required_action",
                        value: ["pending device control"],
                      },
                    ],
                    defaultSort,
                  )
                }
              />
              <Divider />
            </>
            <CommissioningItem
              title="Pending technical approval"
              description="Waiting for technical approval by an admin"
              value={pending_technical_approval}
              onClick={() =>
                handleFilterClick(
                  [{ type: "commissioning_required_action", value: ["pending technical approval"] }],
                  defaultSort,
                )
              }
            />

            <CommissioningItem
              title="Pending contract approval"
              description="Waiting for contract approval by an admin"
              value={pending_contract_approval}
              onClick={() =>
                handleFilterClick(
                  [{ type: "commissioning_required_action", value: ["pending contract approval"] }],
                  defaultSort,
                )
              }
            />
            <CommissioningItem
              title="Pending network operator metering data"
              description="Waiting for metering data from the network operator"
              value={pending_network_operator_metering_data}
              onClick={() =>
                handleFilterClick(
                  [
                    {
                      type: "commissioning_required_action",
                      value: ["pending network operator metering data"],
                    },
                  ],
                  defaultSort,
                )
              }
            />
            <CommissioningItem
              title="Pending network operator metering validation"
              description="Waiting for network operator metering approval by an admin"
              value={pending_network_operator_metering_validation}
              onClick={() =>
                handleFilterClick(
                  [
                    {
                      type: "commissioning_required_action",
                      value: ["pending network operator metering validation"],
                    },
                  ],
                  defaultSort,
                )
              }
            />
          </>
        )}
      </Stack>
    </LandingCard>
  );
}

export default CommissioningCard;

function CommissioningItem({ title, value, description, onClick }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        width: "100%",
        alignItems: "center",
        display: "flex",
        textAlign: "left",
        borderRadius: "10px",
        padding: "0px",
        "&:hover": { backgroundColor: "#f3f3f3" },
      }}
    >
      <Box
        sx={{
          width: "60px",
          height: "60px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f3f3f3",
          borderRadius: "10px",
          marginRight: "12px",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          color={"#333"}
          sx={{ textAlign: "center", fontSize: "22px", lineHeight: "1.2em" }}
        >
          {value}
        </Typography>
        <Typography fontSize={12} sx={{ lineHeight: "1em" }}>
          SITES
        </Typography>
      </Box>

      <Stack sx={{ flexGrow: 1 }}>
        <Typography variant="h6" fontSize={16}>
          {title}
        </Typography>
        <Typography variant="caption">{description}</Typography>
      </Stack>

      {/*
            actionRequired && value && value > 0 ? <Typography variant="caption" color={"red"} sx={{textAlign: "right", width: "70px", lineHeight: "1.5em"}}>
            ACTION REQUIRED
        </Typography> : null
        */}
      <ChevronRightIcon fontSize="large" sx={{ justifySelf: "flex-end", color: "#bbb" }} />
    </ButtonBase>
  );
}
